"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _react = _interopRequireDefault(require("react")),
    _lodash = _interopRequireDefault(require("lodash.memoize")),
    _classnames = _interopRequireDefault(require("classnames")),
    _card = require("../../styles/card"),
    _CardOverlayContainer = _interopRequireDefault(require("../CardOverlay/CardOverlayContainer"));

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      (0, _defineProperty2["default"])(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

function _createSuper(a) {
  return function () {
    var b,
        c = (0, _getPrototypeOf2["default"])(a);

    if (_isNativeReflectConstruct()) {
      var d = (0, _getPrototypeOf2["default"])(this).constructor;
      b = Reflect.construct(c, arguments, d);
    } else b = c.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, b);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (a) {
    return !1;
  }
}

var CardItem = function (a) {
  function b(a) {
    var d;
    return (0, _classCallCheck2["default"])(this, b), d = c.call(this, a), d.handleMouseMovement = (0, _lodash["default"])(function (a) {
      var b = a.isHovered;
      return function (a) {
        d._card && a.relatedTarget && !b && a.target && a.relatedTarget.nodeType && d._card.contains(a.relatedTarget) || d.setState({
          isHovered: b
        });
      };
    }), d.getOverlayProps = (0, _lodash["default"])(function () {
      var a = d.props.overlayProps;
      if (!a || !a.more || !a.more.options) return a;
      var b = a.more.options.map(function (a) {
        return _objectSpread({}, a, {
          action: function action() {
            return d.actionWrapper(a.action);
          }
        });
      });
      return _objectSpread({}, a, {
        more: _objectSpread({}, a.more, {
          options: b
        })
      });
    }), d.actionWrapper = function (a) {
      a(), d.setState({
        isHovered: !1
      });
    }, d.setCardRef = function (a) {
      d._card = a;
    }, d.state = {
      isHovered: !1
    }, d;
  }

  (0, _inherits2["default"])(b, a);

  var c = _createSuper(b);

  return (0, _createClass2["default"])(b, [{
    key: "render",
    value: function render() {
      var a = this.state.isHovered,
          b = this.props.children,
          c = this.getOverlayProps();
      return _react["default"].createElement("div", {
        className: (0, _classnames["default"])("card-item", _card.CARD_ITEM),
        onMouseOver: this.handleMouseMovement({
          isHovered: !0
        }),
        onFocus: this.handleMouseMovement({
          isHovered: !0
        }),
        onMouseLeave: this.handleMouseMovement({
          isHovered: !1
        }),
        onBlur: this.handleMouseMovement({
          isHovered: !1
        }),
        ref: this.setCardRef
      }, b, a && c && _react["default"].createElement(_CardOverlayContainer["default"], c));
    }
  }]), b;
}(_react["default"].Component),
    _default = CardItem;

exports["default"] = _default;